require('../../modules/es6.object.get-prototype-of');

module.exports = require('../../modules/_core').Object.getPrototypeOf;